<template>
	<div class="mhp">
		<div class="mhp__overlay" @click="hiddenModal"></div>
		<!-- Modal window -->
		<div class="mhp__modal">
			<!-- /////////////////// -->
			<div
				v-for="(item, index) in items"
				:key="index"
				class="mhp__modal-row"
				@mouseover="onHover(index)"
				@mouseleave="onMouseleave(index)"
				@click="onClickRedirect(item.routeName)"
			>
				<div class="mhp__modal-row-icon">
					<IconPayment
						v-if="ICON.PAY === index"
						:is-hover="hover.index === index && hover.isHover"
					/>
					<!--					<IconSettingsProfile-->
					<!--						v-if="ICON.PROFILE === index"-->
					<!--						:is-hover="hover.index === index && hover.isHover"-->
					<!--					/>-->
					<IconExit
						v-if="ICON.EXIT === index"
						:is-hover="hover.index === index && hover.isHover"
					/>
				</div>
				<div
					:class="
						hover.index === index && hover.isHover
							? 'mhp__modal-row-label_green'
							: 'mhp__modal-row-label'
					"
				>
					{{ item.name }}
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { mapActions } from "vuex";
import { IModal } from "@/interfaces/IModal";
import IconPayment from "@/components/icons/IconPayment.vue";
import IconSettingsProfile from "@/components/icons/IconSettingsProfile.vue";
import IconExit from "@/components/icons/IconExit.vue";
import ModalBottomProfile from "@/components/modal/ModalBottomProfile.vue";

@Options({
	props: {
		tariffType: { type: Number, default: 0 },
	},

	components: {
		ModalBottomProfile,
		IconExit,
		IconSettingsProfile,
		IconPayment,
	},

	methods: {
		...mapActions("instanceModule", ["modalProfileAction"]),
		...mapActions("authModule", ["checkAuthAction", "logoutAction"]),
	},
})
export default class ModalHeaderProfile extends Vue {
	// Props declaration
	public tariffType: number;

	// Const declaration
	public readonly TARIFF = { FREE: 1 };

	// TODO - временно
	// public ICON = { PAY: 0, PROFILE: 1, EXIT: 2 };
	public ICON = {};
	public hover = { index: 0, isHover: false };
	public items = [
		{ name: "Оплата", routeName: "payment" },
		// TODO - временно
		// { name: "Настройка профиля", routeName: "setting-profile" },
		{ name: "Выйти", routeName: "login" },
	];

	// ************************************************************
	// Define mapActions
	public modalProfileAction!: (payload: IModal) => void;
	public checkAuthAction!: () => void;
	public logoutAction!: () => Promise<void>;

	/**
	 * Hook mounted
	 */
	public mounted() {
		if (this.tariffType === this.TARIFF.FREE) {
			// Удаляем оплату из списка
			this.items.splice(0, 1);
			this.ICON = { EXIT: 0 };
		} else {
			this.ICON = { PAY: 0, EXIT: 1 };
		}
	}

	/**
	 * Скрывает модальное окно
	 */
	public hiddenModal() {
		this.modalProfileAction({ isShow: false });
	}

	/**
	 * Handle hover event
	 * @param index
	 */
	public onHover(index: number) {
		this.hover.isHover = true;
		this.hover.index = index;
	}

	/**
	 * Handle mouseleave event
	 */
	public onMouseleave() {
		this.hover.isHover = false;
	}

	/**
	 * Переход на другую страницу
	 * @param routeName
	 * @param id
	 */
	public async onClickRedirect(routeName: string, id?: number) {
		if (routeName === "login") {
			await this.logoutAction();
			await this.checkAuthAction();
		}
		this.$router.push({ name: routeName, params: { id: id } });
		this.hiddenModal();
	}
}
</script>

<style scoped lang="scss">
.mhp {
	user-select: none;
	padding: 0 16px;
	&__overlay {
		display: block;
		position: fixed;
		z-index: 1;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		overflow: auto;
	}

	&__modal {
		display: flex;
		flex-direction: column;
		position: absolute;
		right: 16px;
		margin-top: -10px;
		padding: 12px 6px;
		min-width: 300px;
		background-color: rgb(255, 255, 255);
		border-radius: 12px;
		border: 1px solid rgb(223, 230, 238);
		box-shadow: 0 4px 0 -4px rgba(16, 24, 64, 0.04);
		z-index: 2;
	}

	&__modal-row {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		cursor: pointer;
	}

	&__modal-row-icon {
		padding: 8px;
	}

	&__modal-row-label {
		font-size: 16px;
		color: rgb(49, 49, 50);
	}
	&__modal-row-label_green {
		color: var(--theme-color);
	}
}
</style>
